//      
import React from 'react';
                                               
                                                                         
import ConnectedDraggable from './connected-draggable';
import useRequiredContext from '../use-required-context';
import DroppableContext, {
                             
} from '../context/droppable-context';



// We can use this to render a draggable with more control
// It is used by a Droppable to render a clone
export function PrivateDraggable(props                 ) {
  const droppableContext                        = useRequiredContext(
    DroppableContext,
  );
  // The droppable can render a clone of the draggable item.
  // In that case we unmount the existing dragging item
  const isUsingCloneFor               = droppableContext.isUsingCloneFor;
  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return <ConnectedDraggable {...props} />;
}

// What we give to consumers
export function PublicDraggable(props                ) {
  // default values for props
  const isEnabled          =
    typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  const canDragInteractiveElements          = Boolean(
    props.disableInteractiveElementBlocking,
  );
  const shouldRespectForcePress          = Boolean(
    props.shouldRespectForcePress,
  );

  return (
    <PrivateDraggable
      {...props}
      isClone={false}
      isEnabled={isEnabled}
      canDragInteractiveElements={canDragInteractiveElements}
      shouldRespectForcePress={shouldRespectForcePress}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/draggable/draggable-api.jsx